// UGC gallery — mobile scroll progress bar.
// The gallery is a plain overflow-x carousel; on mobile we mirror its scroll position into
// the green progress bar beneath it. Desktop (grid, no overflow) has scrollWidth == clientWidth
// so progress stays put and the bar is display:none anyway.
(() => {
  const galleries = [...document.querySelectorAll('[data-ugc-gallery]')];
  if (!galleries.length) return;

  galleries.forEach((gallery) => {
    const wrap = gallery.closest('.ugc__gallery-wrap');
    const fill = wrap && wrap.querySelector('.ugc__progress-fill');
    if (!fill) return;

    let raf = null;
    const update = () => {
      raf = null;
      const max = gallery.scrollWidth - gallery.clientWidth;
      if (max <= 0) return;
      const ratio = Math.min(1, Math.max(0, gallery.scrollLeft / max));
      // fill grows from a resting 40% up to 100% as you reach the end
      const pct = 40 + ratio * 60;
      fill.style.width = pct.toFixed(1) + '%';
    };
    const onScroll = () => {
      if (raf == null) raf = requestAnimationFrame(update);
    };

    gallery.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  });
})();
